// ISSUE_VIEW_MOUNTED
export const ISSUE_VIEW_MOUNTED = 'ISSUE_VIEW_MOUNTED' as const;
export type IssueViewMountedAction = {
	type: typeof ISSUE_VIEW_MOUNTED;
};

export const issueViewMounted = (): IssueViewMountedAction => ({ type: ISSUE_VIEW_MOUNTED });
